<template>
    <div class="main_container main_background">
        <!-- <div class="bg"></div> -->
        
        <div class="img_container">
            <img src="../assets/img/main_title.png" class="title_image">
        </div>

        <div class="bottom_btn_container mobile_margin">
            <div class="bottom_one_btn" @click="next">{{$t('btn_title_start')}}</div>
        </div>
        <div style="position:fixed; top:10px; left:10px; border:1px solid black; cursor:pointer;" @click="playBgm">음악켜기</div>

        <!-- <audio id="audio-fail" src="../assets/beep.mp3" preload></audio> -->
    </div>
</template>

<script>
export default {
    name: 'TitleView',
    methods: {
        next: function() {
            this.$router.push('/gameList')
        },
        playBgm: function() {
            let sound = document.getElementById("bgm");
            sound.play();
            // this.$bgm()
        }
    }
}
</script>

<style scoped>

@keyframes animatedBackground {
    from {
        background-position: 0 0;
    }
    to {
        background-position: -10000px -10000px;
    }
}
.bg {
    /* 크기잡아야 함 */
    position: fixed;
    background-repeat: repeat;
    background-image: url("../assets/img/main_title_deco.png");
    background-size: calc(2560px/2) calc(1240px/2);
    /* background-position-x: 0px; */
    /* background-position-y: 0px; */
    /* background-color: #eFeFeF; */
    animation: animatedBackground 500s linear infinite;
    /* transform: rotate(30deg); */
}

/* pc */
@media screen and (min-width: 415px) {
    .img_container {
        text-align: center;
        margin: 145px 0px;
    }
    .title_image {
        width: 660px;
    }
    .main_background {
        background-repeat: repeat;
        background-image: url("../assets/img/main_title_deco.png");
        background-size: calc(2560px/2) calc(1240px/2);
        animation: animatedBackground 500s linear infinite;
    }
    .mobile_margin {
        margin-bottom: 0px;
    }
}

/* mobile */
@media screen and (max-width: 414px) {
    .img_container {
       text-align: center;
        margin: 180px 0px;
    }
    .title_image {
        width: 300px;
    }
    .main_background {
        background-repeat: repeat;
        background-image: url("../assets/img/main_title_deco.png");
        background-size: calc(2560px/4) calc(1240px/4);
        animation: animatedBackground 500s linear infinite;
    }
    .mobile_margin {
        margin-bottom: 120px;
    }
}

</style>
